import { Instagram, Mail } from "lucide-react";
import type { ComponentProps, ReactNode } from "react";
import { confirmedInstagramUrl, confirmedSupportEmail, confirmedWhatsAppLink } from "./data/public-services";
import type { PublicConfig } from "./lib/api";
import "./footer-contacts.css";

type FooterContactsProps = {
  config: PublicConfig | null;
  onHome: () => void;
  onToast: (message: string) => void;
};

type SocialContactProps = {
  label: string;
  href: string | null;
  unavailableMessage: string;
  onToast: (message: string) => void;
  className?: string;
  children: ReactNode;
};

function WhatsAppIcon(props: ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d="M20 11.5a8 8 0 0 1-11.7 7.1L4 20l1.5-4A8 8 0 1 1 20 11.5Z" />
      <path d="M9.2 8.3c.3-.7.7-.7 1-.7h.3c.3 0 .5.1.6.5l.7 1.7c.1.3.1.5-.1.7l-.5.6c.5 1 1.3 1.8 2.4 2.4l.6-.5c.2-.2.4-.2.7-.1l1.7.7c.4.1.5.3.5.6v.3c0 .3 0 .7-.7 1-.5.2-1.1.3-1.7.1-2.9-.9-5.3-3.3-6.2-6.2-.2-.6-.1-1.2.1-1.7Z" />
    </svg>
  );
}

function SocialContact({ label, href, unavailableMessage, onToast, className = "", children }: SocialContactProps) {
  const classes = `footer-social-icon ${className}`.trim();
  if (href) {
    return <a className={classes} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>{children}<span className="footer-social-label">{label}</span></a>;
  }
  return <button className={classes} type="button" aria-label={`${label}: non ancora disponibile`} title={label} onClick={() => onToast(unavailableMessage)}>{children}<span className="footer-social-label">{label}</span></button>;
}

/** Compact, fail-closed social contacts for the footer. */
export default function FooterContacts({ config, onHome, onToast }: FooterContactsProps) {
  const instagramUrl = confirmedInstagramUrl(config);
  const whatsappUrl = confirmedWhatsAppLink(config);
  const supportEmail = confirmedSupportEmail(config);

  return (
    <><div className="footer-brand-row">
      <button className="wordmark" type="button" aria-label="GRUVO, home" onClick={onHome}>gruvo<span className="logo-dot" /></button>
      <div className="footer-social-icons" aria-label="Canali di contatto GRUVO">
        <SocialContact label="Instagram" href={instagramUrl} unavailableMessage="Instagram sarà disponibile presto." onToast={onToast}><Instagram size={20} /></SocialContact>
        <SocialContact label="WhatsApp" href={whatsappUrl} unavailableMessage="WhatsApp sarà disponibile presto." onToast={onToast} className="footer-social-whatsapp"><WhatsAppIcon width={21} height={21} /></SocialContact>
        <SocialContact label="E-mail di assistenza" href={supportEmail ? `mailto:${supportEmail}` : null} unavailableMessage="L’e-mail di assistenza sarà disponibile presto." onToast={onToast}><Mail size={20} /></SocialContact>
      </div>
    </div><a className="footer-technical-directory" href="/catalogo/">Catalogo tecnico e schede dei modelli</a></>
  );
}
